import React, { useState, useEffect } from "react";
import {
  Container,
  Nav,
  Navbar,
  Modal,
  Col,
  Row,
  Table,
  Offcanvas,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { Calender, DropDownUI, TextInputForm, LoadingSpinner } from "../components/Forms";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useLocation, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";
import { MdOutlineClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import { ButtonBase } from "@mui/material";
const ProductHistory = [
  "S No",
  "Date",
  "Receipt No.",
  "Name",
  "Total",
  "Status",
];
const DropList = [
  {
    value: "Admin",
    label: "Admin",
  },
  {
    value: "Super Admin",
    label: "Super Admin",
  },
  {
    value: "Staff",
    label: "Staff",
  },
];
const user = [
  {
    voucher_date: "25852",
    party_id: "85963",
    paid: "200",
  },
];
const PayOut = () => {
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [show, setShow] = useState(false);
  const [tempSearchText, setTempSearchText] = useState("");
  const handleClose = () => {
    setShow(false);
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: "",
      paid: "",
    });
  };
  const handleShow = () => {
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: "",
      paid: "",
    });
    setShow(true);
  };
  const [crtPayOut, setCrtPayOut] = useState(null);
  const handleEditClick = (rowdata) => {
    setCrtPayOut(rowdata);
    setShow(true);
  };
  const [formData, setFormData] = useState({
    party_id: "",
    voucher_date: "",
    paid: "",
  });
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [filterData, setFilterData] = useState({
    search_text: "",
    party_id: "",
    from_date: "",
    to_date: "",
  });

  const handleChanges = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtPayOut !== null) {
      setCrtPayOut({
        ...crtPayOut,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };

  const setLabel = (value, field) => {
  if (!value || value === "") {
    setFormData((prev) => ({ ...prev, [field]: "" }));
    return;
  }

  // Convert from DD-MM-YYYY to YYYY-MM-DD if needed
  const formattedDate = moment(value, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");

  if (!moment(formattedDate, "YYYY-MM-DD", true).isValid()) {
    console.error(`Invalid date for ${field}:`, value);
    return;
  }

  setFormData((prev) => ({
    ...prev,
    [field]: formattedDate,
  }));
};

  const setLabell = (value, field) => {
    if (!value || value === "") {
      setFilterData((prev) => ({
        ...prev,
        [field]: "",
      }));
      return;
    }
    const formattedDate = moment(value).format("YYYY-MM-DD");
    if (!moment(formattedDate).isValid()) {
      console.error(`Invalid date for ${field}:`, value);
      return;
    }
    setFilterData((prev) => ({
      ...prev,
      [field]: formattedDate,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [purchasepartyData, setPurchasepartyData] = useState([]);
  const [userData, setUserData] = useState([]);

  // Unified fetch function
  const fetchAllPayoutData = async () => {
    setLoading(true);
    try {
      const companyId = localStorage.getItem("companyId");
      if (!companyId) {
        throw new Error("Company ID not found in localStorage");
      }

      const [partyRes, payoutRes] = await Promise.all([
        fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        }),
        fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: filterData.search_text || "", // 👈 use the current filterData
            party_id: filterData.party_id || "",
            from_date: filterData.from_date || "",
            to_date: filterData.to_date || "",
            company_id: companyId,
          }),
        }),
      ]);

      const partyData = await partyRes.json();
      const payoutData = await payoutRes.json();

      console.log("Party API response:", partyData);
      console.log("Payout API response:", payoutData);

      if (partyData.status === 200) {
        setPurchasepartyData(partyData.data || []);
      } else {
        throw new Error(partyData.msg || "Party fetch failed");
      }

      if (payoutData.status === 200) {
        let filteredData = payoutData.data || [];

        // Filter by voucher_no
        if (filterData.search_text.trim()) {
          const searchLower = filterData.search_text.toLowerCase();
          filteredData = filteredData.filter((item) => {
            return (
              (item.voucher_no && item.voucher_no.toLowerCase().includes(searchLower)) ||
              (item.party_details?.party_name &&
                item.party_details.party_name.toLowerCase().includes(searchLower))
            );
          });
        }
        // Filter by party_id
        if (filterData.party_id) {
          filteredData = filteredData.filter(
            (item) => item.party_id === filterData.party_id
          );
        }

        // Filter by date range
        if (filterData.from_date && filterData.to_date) {
          const fromDate = moment(filterData.from_date).toDate();
          const toDate = moment(filterData.to_date).toDate();
          filteredData = filteredData.filter((item) => {
            const voucherDate = moment(item.voucher_date).toDate();
            return voucherDate >= fromDate && voucherDate <= toDate;
          });
        }

        // Enrich data with party_name
        const enrichedData = filteredData.map((item) => {
          const party = purchasepartyData.find((p) => p.party_id === item.party_id);
          return {
            ...item,
            party_name: party ? party.party_name : "Unknown",
          };
        });

        console.log("Filtered and enriched userData:", enrichedData);
        setUserData(enrichedData);
      } else {
        throw new Error(payoutData.msg || "Payout fetch failed");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch payout data", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
      setUserData([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch on initial mount and when filterData changes
  useEffect(() => {
    clearFilter(); // Reset filters on mount
    fetchAllPayoutData();
  }, []);

  // Update when filterData changes
  useEffect(() => {
    fetchAllPayoutData();
  }, [filterData]);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
    });
    setTempSearchText("");
    setDropdownKey(Date.now());
    closeFilter();
  };

  const handleSubmit = async () => {
  try {
    const companyId = localStorage.getItem("companyId");
    if (!companyId) {
      errorAlert("Company ID missing!");
      return;
    }

    if (!formData.party_id || !formData.voucher_date || !formData.paid) {
      errorAlert("All fields are required!");
      return;
    }

    // ✅ Ensure date format is compatible with MySQL
    const formattedData = {
      ...formData,
      voucher_date: moment(formData.voucher_date, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD"),
    };

    const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    });

    const responseData = await response.json();  // ✅ Only read onc
    console.log("Submit response:", responseData);

    if (responseData.status === 200) {
      setFormData({
        party_id: "",
        voucher_date: "",
        paid: "",
      });
      fetchAllPayoutData();
      successAlert(responseData.msg || "Payout created successfully");
      setTimeout(() => {
        handleClose();
      }, 2000);
    } else {
      errorAlert(responseData.msg || "Failed to create payout");
    }
  } catch (error) {
    console.error("Submission error:", error.message);
    errorAlert("Error while submitting payout");
  }
};

  
  const handleUpdateSubmit = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      if (!companyId) {
        errorAlert("Company ID missing!");
        return;
      }

      if (!crtPayOut.party_id || !crtPayOut.voucher_date || !crtPayOut.paid) {
        errorAlert("All fields are required!");
        return;
      }

      // Format date to YYYY-MM-DD for MySQL
      const [day, month, year] = crtPayOut.voucher_date.split("-");
      const formattedDate = `${year}-${month}-${day}`;

      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          payout_id: crtPayOut.payout_id,
          paid: crtPayOut.paid,
          voucher_date: formattedDate,
          party_id: crtPayOut.party_id,
        }),
      });

      console.log("Payload sent to server:", {
        payout_id: crtPayOut.payout_id,
        paid: crtPayOut.paid,
        voucher_date: formattedDate,
        party_id: crtPayOut.party_id,
      });

      const text = await response.text();
      console.log("Raw response text:", text);

      let responseData;
      try {
        responseData = JSON.parse(text);
      } catch (err) {
        console.error("Failed to parse JSON:", err.message);
        errorAlert("Server returned invalid JSON");
        return;
      }

      if (responseData.status === 200) {
        fetchAllPayoutData();
        successAlert(responseData.msg || "Payout updated successfully");
        setTimeout(() => {
          handleClose();
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Failed to update payout");
      }
    } catch (error) {
      console.error("Error updating payout:", error.message);
      errorAlert("Error while updating payout");
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading PayoutPage..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main p-3 my-2">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Pay Out" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                {/* <span className='mx-2 py-2'> <Buttons lable={<>PDF</>} /></span> */}
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle="Purchase Bill" />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons
                      onClick={closeFilter}
                      label={<MdOutlineClose />}
                    />
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    key={dropdownKey}
                    labelname="Search Receipt"
                    placeholder="Enter Receipt No"
                    name="search_text"
                    value={tempSearchText}
                    onChange={(e) => setTempSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setFilterData((prev) => ({
                          ...prev,
                          search_text: tempSearchText,
                        }));
                      }
                    }}
                  />
                </div>
                <div className="py-3">
                  <DropDownUI
                    key={dropdownKey}
                    optionlist={purchasepartyData.map((user) => ({
                      value: user.party_id,
                      label: user.party_name,
                    }))}
                    placeholder="Select Party"
                    labelname="Select Party"
                    name="party_id"
                    value={filterData.party_id}
                    onChange={(updatedFormData) =>
                      setFilterData({
                        ...filterData,
                        party_id: updatedFormData.party_id,
                      })
                    }
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      key={dropdownKey}
                      setLabel={(date) => setLabell(date, "from_date")}
                      selectedDate={filterData.from_date}
                      calenderlabel="From Date"
                    />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      key={dropdownKey}
                      setLabel={(date) => setLabell(date, "to_date")}
                      selectedDate={filterData.to_date}
                      calenderlabel="To Date"
                    />
                  </Col>
                  <Col lg="12" className="align-self-center">
                    <div className="my-5 text-center">
                      <ClickButton label={<>Clear</>} onClick={clearFilter} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Transactions" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  {" "}
                  <Buttons lable={<>Add New</>} onClick={handleShow} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll">
            <TableUI
              headers={ProductHistory}
              body={userData}
              type="purchasepayout"
              pageview="yes"
              handleEditClick={handleEditClick}
              onDelete={fetchAllPayoutData}
            />
          </div>
        </div>
      </Container>
      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header>
          <Modal.Title>
            <PageHead
              pagehead={`PayOut${crtPayOut !== null ? " Update" : " Creation"}`}
              onClick={handleClose}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Table>
              <tr>
                <td className="w-50">
                  <DropDownUI
                    optionlist={purchasepartyData.map((user) => ({
                      value: user.party_id,
                      label: user.party_name,
                    }))}
                    placeholder="Select Party"
                    labelname="Select Party"
                    name="party_id"
                    value={crtPayOut !== null ? crtPayOut.party_id : formData.party_id}
                    onChange={(updatedFormData) => {
                      if (crtPayOut !== null) {
                        setCrtPayOut({
                          ...crtPayOut,
                          party_id: updatedFormData.party_id,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          party_id: updatedFormData.party_id,
                        });
                      }
                    }}
                  />
                </td>
                <td className="float-end">
                  <div className="py-3">
                    <Calender
                      setLabel={(date) => setLabel(date, "voucher_date")}
                      selectedDate={
                        crtPayOut !== null ? crtPayOut.voucher_date : formData.voucher_date
                      }
                      calenderlabel="Date"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div className="py-3 w-75 ms-auto">
                    <TextInputForm
                      labelname="Paid"
                      placeholder="Paid"
                      name="paid"
                      value={crtPayOut !== null ? crtPayOut.paid : formData.paid}
                      onChange={(e) => handleChange(e, "paid")}
                    />
                  </div>
                </td>
              </tr>
            </Table>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Col lg="12" md="12" xs="12" className="py-5 align-self-center">
            <div className="text-center">
              {crtPayOut !== null ? (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <Buttons label={<>"Update"</>} onClick={handleUpdateSubmit} />
                  </span>
                  <span className="mx-2">
                    <Buttons label={<>"Cancel"</>} onClick={handleClose} />
                  </span>
                </>
              ) : (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <Buttons label={<>"Submit"</>} onClick={handleSubmit} />
                  </span>
                  <span className="mx-2">
                    <Buttons label={<>"Cancel"</>} onClick={handleClose} />
                  </span>
                </>
              )}
            </div>
          </Col>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PayOut;
